import {DataGrid, esES, GridColumns} from "@mui/x-data-grid";
import React, {useState} from "react";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import CheckIcon from "@mui/icons-material/Check";
import {green, red} from "@mui/material/colors";
import CloseIcon from "@mui/icons-material/Close";
import {Avatar, Stack, Typography} from "@mui/material";
import {DeleteIconButton, EditIconButton} from "../../../../../components/buttons/Buttons";
import {dateFormatter} from "../../../../../utils/formatters";
import {EntityWithIdFields} from "../../../../../types/baseEntities";
import {ClientRelationshipView, ClientRelationshipViewFields} from "../../../../../types/client/clientData";
import {numberFormatter} from "../../../../../utils/formatters/numberFormatter";


interface ShareholdersDataGridProps {
    relationships: ClientRelationshipView[],
    onEdit?: (client: ClientRelationshipView) => void,
    onDelete?: (clientId: number) => void
}


const ShareholdersDataGrid = ({relationships, onEdit, onDelete} : ShareholdersDataGridProps) => {
    const [pageSize, setPageSize] = useState<number>(5)

    const cols: GridColumns = [
        {
            flex: 0.3,
            field: 'descClienteTipo',
            headerName: 'Cliente',
            renderCell: (params: any) => (
                <Stack direction={'row'} spacing={4} alignItems={'center'}>
                    {params.row[ClientRelationshipViewFields.ClientTypeDesc] === 'Fisica' ? <Avatar><PersonIcon /></Avatar> : <Avatar><BusinessIcon /></Avatar>}
                    <Stack spacing={1}>
                        <Typography fontWeight={600} fontSize={14}>{params.row[ClientRelationshipViewFields.BusinessName]}</Typography>
                        <Typography fontSize={12} color={'grey'} fontWeight={500}>
                            {numberFormatter.toCuitString(params.row[ClientRelationshipViewFields.CUIT])}
                        </Typography>
                    </Stack>
                </Stack>
            )
        },
        {
            flex: 0.12,
            field: 'descClienteRelacionTipo',
            minWidth: 110,
            headerName: 'Cargo',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{params.row[ClientRelationshipViewFields.RelationshipTypeDesc]}</Typography>
            )
        },
        {
            flex: 0.1,
            minWidth: 80,
            field: 'porcParticicacion',
            headerName: '% Participación',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{params.row[ClientRelationshipViewFields.Participation]}</Typography>
            )
        },
        {
            flex: 0.12,
            minWidth: 80,
            field: 'fechaNacimiento',
            headerName: 'Fecha de Nacimiento',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{dateFormatter.toShortDate(params.row[ClientRelationshipViewFields.BirthDate]) || '-'}</Typography>
            )
        },
        {
            flex: 0.15,
            field: 'esFirmante',
            minWidth: 120,
            headerName: 'Firmante de documentación',
            renderCell: (params: any) => (
                params.row[ClientRelationshipViewFields.Signer] ? (
                    <CheckIcon
                        style={{
                            color: green[500],
                        }}
                    />
                ) : (
                    <CloseIcon
                        style={{
                            color: red[500],
                        }}
                    />
                )
            )
        },
        {
            flex: 0.06,
            minWidth: 80,
            field: 'acciones',
            headerName: 'Acciones',
            renderCell: (params: any) => (
                        <Stack direction={'row'} spacing={2} alignItems={'center'}>
                            <EditIconButton onClick={() => onEdit && onEdit(params.row as ClientRelationshipView)} tooltipTitle={'Editar'} />
                            <DeleteIconButton onClick={() => onDelete && onDelete(params.row[EntityWithIdFields.Id])} tooltipTitle={'Eliminar'} />
                        </Stack>
            )
        }
    ]

    const colsView: GridColumns = [
        {
            flex: 0.3,
            field: 'descClienteTipo',
            headerName: 'Cliente',
            renderCell: (params: any) => (
                <Stack direction={'row'} spacing={4} alignItems={'center'}>
                    {params.row[ClientRelationshipViewFields.ClientTypeDesc] === 'Fisica' ? <Avatar><PersonIcon /></Avatar> : <Avatar><BusinessIcon /></Avatar>}
                    <Stack spacing={1}>
                        <Typography fontWeight={600} fontSize={14}>{params.row[ClientRelationshipViewFields.BusinessName]}</Typography>
                        <Typography fontSize={12} color={'grey'} fontWeight={500}>{params.row[ClientRelationshipViewFields.CUIT]}</Typography>
                    </Stack>
                </Stack>
            )
        },
        {
            flex: 0.12,
            field: 'descClienteRelacionTipo',
            minWidth: 110,
            headerName: 'Cargo',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{params.row[ClientRelationshipViewFields.RelationshipTypeDesc]}</Typography>
            )
        },
        {
            flex: 0.1,
            minWidth: 80,
            field: 'porcParticicacion',
            headerName: '% Participación',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{params.row[ClientRelationshipViewFields.Participation]}</Typography>
            )
        },
        {
            flex: 0.12,
            minWidth: 80,
            field: 'fechaNacimiento',
            headerName: 'Fecha de Nacimiento',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{dateFormatter.toShortDate(params.row[ClientRelationshipViewFields.BirthDate]) || '-'}</Typography>
            )
        },
        {
            flex: 0.15,
            field: 'esFirmante',
            minWidth: 120,
            headerName: 'Firmante de documentación',
            renderCell: (params: any) => (
                params.row[ClientRelationshipViewFields.Signer] ? (
                    <CheckIcon
                        style={{
                            color: green[500],
                        }}
                    />
                ) : (
                    <CloseIcon
                        style={{
                            color: red[500],
                        }}
                    />
                )
            )
        }
    ]
    
    return (
        <>
            {
                relationships &&
                <DataGrid
                    columns={(onEdit && onDelete) ? cols : colsView}
                    rows={relationships}
                    localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                    autoHeight
                    rowsPerPageOptions={[5, 10, 25]}
                    pageSize={pageSize}
                    onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                />
            }
        </>
    )
}


export default ShareholdersDataGrid